import { ADDRESS, ASSIGNED_PERSON, ASSOCIATED_FACILITIES, ASSOCIATED_FACILITY, CALLING_PERSON, CAREGIVER, CAREGIVERS, CITY, CRM, FIRST_NAME, FUNDING_SOURCE, FUNDING_SOURCES, LAST_NAME, MEDICATION, MEDICATIONS, PATIENT_ASSIGNMENTS, PATIENT_CONDITION, PATIENT_MEDICATIONS, PHONE, PHONES, PHYSICIAN, PHYSICIANS, PROGRAM_SITE_NAME, REFERRAL_SOURCE, REFERRAL_TAKEN_BY, REFERRAL_TAKEN_ON, SOURCE, STATE, STREET, STREET2, ZIP } from './constants';
import defaults from '../../translations/en.json';

const getCurrentFacility = associatedFacilities => associatedFacilities && (associatedFacilities.type ? associatedFacilities : associatedFacilities.find(fac => fac.type === defaults.currentFacility));

const getReferringFacility = associatedFacilities => associatedFacilities && (associatedFacilities.type === defaults.referringFacility ? associatedFacilities.name : Array.isArray(associatedFacilities) && associatedFacilities.find(fac => fac.type === defaults.referringFacility).name); // dto stores dnr as an assigned person


const getDNR = patientAssignments => patientAssignments && (patientAssignments[LAST_NAME] || patientAssignments.find(assignment => assignment.type === defaults.dnr)[LAST_NAME]);

export const parseFacesheet = facesheet => {
  const {
    allergies,
    patient: facesheetPatient,
    comments
  } = facesheet;
  const associatedFacilities = facesheet[ASSOCIATED_FACILITIES] && facesheet[ASSOCIATED_FACILITIES][ASSOCIATED_FACILITY];
  const physicians = facesheet[PHYSICIANS] && facesheet[PHYSICIANS][PHYSICIAN];
  const caregivers = facesheet[CAREGIVERS] && facesheet[CAREGIVERS][CAREGIVER];
  const patientAssignments = facesheet[PATIENT_ASSIGNMENTS] && facesheet[PATIENT_ASSIGNMENTS][ASSIGNED_PERSON];
  const patientCondition = facesheet[PATIENT_CONDITION];
  const patientMedications = facesheet[PATIENT_MEDICATIONS] && facesheet[PATIENT_MEDICATIONS][MEDICATIONS] && facesheet[PATIENT_MEDICATIONS][MEDICATIONS][MEDICATION];
  const programSiteName = facesheet[PROGRAM_SITE_NAME];
  const noAssignments = patientAssignments && patientAssignments[LAST_NAME] === defaults.unanswered;
  const primaryFundingSource = facesheetPatient[FUNDING_SOURCES] && facesheetPatient[FUNDING_SOURCES][FUNDING_SOURCE];
  const callingPerson = facesheet[REFERRAL_SOURCE] && facesheet[REFERRAL_SOURCE][CALLING_PERSON];
  const referralTakenBy = facesheet[REFERRAL_TAKEN_BY];
  const referralSource = facesheet[REFERRAL_SOURCE] && facesheet[REFERRAL_SOURCE][SOURCE];
  const crm = facesheet[REFERRAL_SOURCE] && facesheet[REFERRAL_SOURCE][CRM];
  const referralTakenOn = facesheet[REFERRAL_TAKEN_ON];
  const currentFacility = getCurrentFacility(associatedFacilities);
  const referringFacility = getReferringFacility(associatedFacilities);
  const dnr = getDNR(patientAssignments);
  return {
    associatedFacilities,
    physicians,
    caregivers,
    patientAssignments,
    patientCondition,
    patientMedications,
    currentFacility,
    programSiteName,
    noAssignments,
    allergies,
    facesheetPatient,
    comments,
    primaryFundingSource,
    dnr,
    callingPerson,
    crm,
    referralTakenBy,
    referralSource,
    referralTakenOn,
    referringFacility
  };
};
export const parseName = dto => `${dto[FIRST_NAME]} ${dto[LAST_NAME]}`;
export const parsePhones = dto => dto[PHONES] && dto[PHONES][PHONE];
export const parseAddress = dto => {
  const address = dto[ADDRESS];
  const street = address && address[STREET];
  const street2 = address && address[STREET2];
  const city = address && address[CITY];
  const zip = address && address[ZIP];
  const state = address && address[STATE] && String(address[STATE]).toUpperCase();
  return {
    street,
    street2,
    city,
    state,
    zip
  };
};